import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {Table} from '@spaced-out/ui-design-system/lib/components/Table';

import {useHistory} from 'src/rerouter/index';

import {
  Panel,
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {TabList, Tab} from '@spaced-out/ui-design-system/lib/components/Tabs';
import {
  ButtonTextSmall,
  SubTitleLarge,
  SubTitleMedium,
  BodySmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {useSelector, useDispatch} from 'react-redux';
import CandidateDetailsCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/candidate-details-card/candidate-details';
import ResumeCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/resume/resume';
import {
  getJobInformation,
  getCandidateFeedbacks,
  getInterviewSchedules,
  getApplicantInformation,
  getInterviewFlow,
  getJobScoreCards,
} from 'src/action-creators/crm';
import {JobDescription} from 'src/components/crm/lib/job-description/job-description';
import {selectJobInformation} from 'src/selectors/crm';

import {JobDetailsTab} from 'src/components/crm/lib/job-details-tab/job-details-tab';
import GetCompletedInterviewData from 'src/components/crm/lib/candidate-evaluation/get-completed-interview-data';
import OnBehalfEvaluation from 'src/components/crm/lib/candidate-evaluation/on-behalf-evaluation';
import css from 'src/components/crm/jobs/job-info/overview/feedbacks/submit-feedbacks.css';

import classify from 'src/utils/classify';
import {getSubmitFeedbackTabs} from 'src/components/crm/constant';
import ApplicantFeedbacks from 'src/components/crm/applicants/body/tabComponents/feedback-and-scorecards/feedback';


type submitFeedbacksProps = {
  candidateStepId: string;
  candidateId: number;
  jobId: string;
  isOpen: boolean;
  handleClose?: () => void;
  intialTabId?: string;
  tabId?: string;
  type?: string;
  from?: string;
};

const SubmitFeedbacks = ({
  isOpen,
  handleClose,
  candidateStepId,
  candidateId,
  jobId,
  tabId,
  type,
  from,
}: submitFeedbacksProps) => {
  const history = useHistory();
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const SUBMIT_FEEDBACK_TABS = getSubmitFeedbackTabs(t);
  const {feedbackTabId, candidateName: candidateNameQuery} =
    history.location.query;

  const intialTabId =
    SUBMIT_FEEDBACK_TABS.find((tab) => tab.tabId === feedbackTabId) ||
    SUBMIT_FEEDBACK_TABS[0];
  const [refetchApplicantData, setRefetchApplicantData] = React.useState(false);

  const [selected, setSelected] = React.useState(intialTabId);
  const jobInformation = useSelector(selectJobInformation);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (jobId && Number(jobId) !== Number(jobInformation?.jobId)) {
      dispatch(getJobInformation(jobId));
    }
  }, [jobId]);
  const fetchApplicantData = async () => {
    try {
      if (jobId) {
        await Promise.all([
          dispatch(getApplicantInformation(candidateId, jobId)),
          dispatch(getInterviewFlow(jobId.toString(), candidateId.toString())),
          dispatch(getJobScoreCards(Number(jobId))),
        ]);
      } else {
        await Promise.all([dispatch(getApplicantInformation(candidateId))]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    fetchApplicantData();
  }, [refetchApplicantData]);

  const onSubmit = () => {
    if (from === 'DASHBOARD') {
      dispatch(getCandidateFeedbacks('PENDING'));
      dispatch(getInterviewSchedules('PENDING'));
      dispatch(getCandidateFeedbacks('COMPLETED'));
      dispatch(getInterviewSchedules('COMPLETED'));
    } else {
      dispatch(getCandidateFeedbacks('PENDING', jobId));
      dispatch(getInterviewSchedules('PENDING', jobId));
      dispatch(getCandidateFeedbacks('COMPLETED', jobId));
      dispatch(getInterviewSchedules('COMPLETED', jobId));
    }
  };

  const renderTabContent = () => {
    switch (selected.tabId) {
      case 'FEEDBACK':
        return (
          <div className={css.feedbackContainer}>
            <GetCompletedInterviewData
              stepCandidateId={Number(candidateStepId)}
              loaderComponent={
                <div className={css.loaderContainer}>
                  <CircularLoader />
                </div>
              }
            >
              {}
              {/* @ts-expect-error - TS2322 - Type '(completedInterviewData: any) => Element' is not assignable to type 'ReactNode'. | TS7006 - Parameter 'completedInterviewData' implicitly has an 'any' type. */}
              {(completedInterviewData) => (
                <OnBehalfEvaluation
                  stepCandidate={completedInterviewData}
                  sections={completedInterviewData.sectionSpecifics}
                  scorecard={completedInterviewData.scorecard}
                  step={completedInterviewData.step}
                  updateData={() => {
                    onSubmit();
                    handleClose?.();
                  }}
                  onCancel={() => {
                    handleClose?.();
                  }}
                />
              )}
            </GetCompletedInterviewData>
          </div>
        );
      case 'CANDIDATE_DETAILS':
        return <CandidateDetailsCard candidateId={candidateId} />;
      case 'RESUME':
        return <ResumeCard applicantId={candidateId} jobId={jobId} />;
      case 'BASIC_JOB_DETAILS':
        return (
          <JobDetailsTab jobDetails={jobInformation} hideCustomInfo={true} />
        );
      case 'PAST_REVIEWS':
        return (
          <ApplicantFeedbacks
            jobId={Number(jobId)}
            reloadCandidateData={() =>
              setRefetchApplicantData(!refetchApplicantData)
            }
          />
        );
      case 'JOB_DESCRIPTION':
        return (
          <JobDescription jobInfo={jobInformation} hideExternalJD={true} />
        );

      default:
        return <div>{t('Select_a_tab', 'Select a tab')}</div>;
    }
  };
  return (
    <Panel
      anchor="right"
      initialFocus={1}
      onClose={handleClose}
      size="large"
      tapOutsideToClose
      isOpen={isOpen}
      hideBackdrop={false}
    >
      <PanelHeader onCloseButtonClick={handleClose} size="medium">
        <SubTitleLarge>
          {`${t('Feedbacks', 'Feedbacks')} `}
          {candidateNameQuery ? `${t('for', 'for')} ${candidateNameQuery}` : ''}
        </SubTitleLarge>
      </PanelHeader>

      <div className={css.tabSlot}>
        <TabList
          onSelect={(tab) => {
            setSelected(tab);
            const params = new URLSearchParams(window.location.search);
            params.set('feedbackTabId', tab.tabId);
            history.push(`${window.location.pathname}?${params.toString()}`);
          }}
          selectedTab={{
            label: selected.label,
            tabId: selected.tabId,
          }}
          size="medium"
          classNames={{
            wrapper: classify({
              [css.tablist]: selected.tabId === 'FEEDBACK',
            }),
          }}
          menuWidth="100%"
        >
          {SUBMIT_FEEDBACK_TABS.map(({label, tabId}) => (
            <Tab key={tabId} label={label} tabId={tabId} />
          ))}
        </TabList>
      </div>
      <PanelBody
        className={classify(css.panelBody, {
          [css.padding]: selected.tabId === 'FEEDBACK',
        })}
      >
        {renderTabContent()}
      </PanelBody>
    </Panel>
  );
};

export default SubmitFeedbacks;
